import {Message} from 'common'
import {FirebaseInstances} from './helpers'
import {chatApi} from '../../../lib/api'

export function createChatService(fb: FirebaseInstances) {
  const getUserChat = (
    chatId: string,
    updateChatState: (data: any) => void,
    cancelCallback: (e: Error) => void
  ) => {
    let isActive = true
    let inFlight = false

    const emitMessages = async () => {
      if (!isActive || inFlight) return

      try {
        inFlight = true
        const messages = await chatApi.getMessages<any[]>(chatId)
        if (!isActive) return

        const msgArr = Array.isArray(messages) ? messages : []
        msgArr.forEach((msg: any) => {
          if (msg.offer) {
            updateChatState({
              ...msg,
              offer: {...msg.offer, messageId: msg.id}
            })
          } else {
            updateChatState(msg)
          }
        })
      } catch (error) {
        if (isActive) {
          cancelCallback(error as Error)
        }
      } finally {
        inFlight = false
      }
    }

    emitMessages()
    const intervalId = window.setInterval(emitMessages, 2500)

    return () => {
      isActive = false
      window.clearInterval(intervalId)
    }
  }

  const sendChatMessage = async ({
    chatId,
    dealId: _dealId,
    message,
    buyerContactId: _buyerContactId,
    sellerContactId,
    productId: _productId
  }: {
    message: Message
    chatId: string
    dealId: string
    productId: string
    buyerContactId: string
    sellerContactId: string
  }) => {
    try {
      const adminContactId = sellerContactId || fb.auth?.currentUser?.uid || ''
      const adminPreviewSenderId = fb.auth?.currentUser?.uid || adminContactId
      const readyAttachments = (message.attachment || []).filter((attachment) =>
        Boolean((attachment as any)?.downloadURL)
      ) as Array<{
        downloadURL: string
        name: string
        type?: string
      }>
      const firstAttachment = readyAttachments[0]
      const attachmentType =
        readyAttachments.length === 1
          ? firstAttachment?.type || 'text'
          : readyAttachments.length > 1
          ? 'attachment'
          : 'text'
      await chatApi.sendMessage(chatId, {
        senderContactId: adminContactId,
        previewSenderId: adminPreviewSenderId,
        text: message?.message || '',
        messageType: `admin:${attachmentType}`,
        attachmentUrl: firstAttachment?.downloadURL,
        attachments: readyAttachments
      })

      return {}
    } catch (error) {
      return {error}
    }
  }

  const deleteUserChat = async (chatId: string, _dealId: string) => {
    try {
      await chatApi.deleteChat(chatId)
      return {}
    } catch (error) {
      return {error}
    }
  }

  const deleteChatMessage = async (chatId: string, messageId: string) => {
    try {
      await chatApi.deleteMessage(chatId, messageId)
      return {}
    } catch (error) {
      return {error}
    }
  }

  const markChatAsRead = async (chatId: string) => {
    try {
      await chatApi.markRead(chatId)
      return {}
    } catch (error) {
      return {error}
    }
  }

  const restoreUserChat = async (chatId: string, _dealId: string) => {
    try {
      await chatApi.restoreChat(chatId)
      return {}
    } catch (error) {
      return {error}
    }
  }

  const archiveUserChat = async (chatId: string, _dealId: string) => {
    try {
      await chatApi.archive(chatId)
      return {}
    } catch (error) {
      return {error}
    }
  }

  const unarchiveUserChat = async (chatId: string, _dealId: string) => {
    try {
      await chatApi.unarchive(chatId)
      return {}
    } catch (error) {
      return {error}
    }
  }

  return {
    getUserChat,
    sendChatMessage,
    deleteChatMessage,
    markChatAsRead,
    archiveUserChat,
    unarchiveUserChat,
    deleteUserChat,
    restoreUserChat
  }
}
